import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Async from 'react-select/async';
import cns from 'classnames';

class VerbSelect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            previousValue: null
        };
    }

    static propTypes = {
        value: PropTypes.any,
        onBlur: PropTypes.func,
        selectAsync: PropTypes.bool,
        styleProps: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
        helpBlockSection: PropTypes.any,
        autoFocus: PropTypes.bool,
        name: PropTypes.string,
        disabled: PropTypes.bool,
        labelKey: PropTypes.string,
        valueKey: PropTypes.string,
        className: PropTypes.string,
        options: PropTypes.array,
        clearValue: PropTypes.any,
        isMulti: PropTypes.bool,
        onChange: PropTypes.func,
        getOptionLabel: PropTypes.func,
        getOptionValue: PropTypes.func,
        formatOptionLabel: PropTypes.func,
        selectOptions: PropTypes.object
    };

    componentDidMount() {
        if (this.props.autoFocus) {
            this.selectInput.focus();
        }
    }

    handleBlur = () => {
        if (this.props.onBlur) {
            return this.props.onBlur();
        }
        return null;
    };

    /**
     * @returns {Object <{[labelKey]: String, [valueKey]: String}>}
     *
     * gets the actual value object that will be displayed from the passed
     * in 'value' prop which can be either a simple string (legacy v1) or an object.
     *
     */
    _getDisplayValue = () => {
        const { selectAsync, options = [], value, valueKey = 'value' } = this.props;
        if (selectAsync) {
            return {
                value,
                label: value
            };
        }
        return typeof value === 'object'
            ? value
            : (options || []).filter((option = {}) => option[valueKey] === value)[0];
    };

    /**
     * @returns <Void>
     *
     * this ensures onChange will always be called with the most current value and changeEvent as 1st and 2nd arg
     *
     */
    _handleOnChange = (value, changeEvent) => {
        const { clearValue = '', onChange, isMulti, valueKey = 'value' } = this.props;
        const { previousValue = [] } = this.state;
        if (isMulti && changeEvent.action === 'remove-value' && value === null) {
            const newMultiSelectValue = (previousValue || []).filter(
                (item) => item[valueKey] !== changeEvent.removedValue[valueKey]
            );
            this.setState({ previousValue: newMultiSelectValue });
            return onChange(newMultiSelectValue, changeEvent);
        }

        // handles clearing
        if (changeEvent.action === 'clear' && onChange) {
            this.setState({ previousValue: clearValue });
            return onChange(clearValue, changeEvent);
        }
        this.setState({ previousValue: value });
        return onChange(value, changeEvent);
    };

    render() {
        const {
            selectAsync,
            disabled = false,
            labelKey = 'label',
            valueKey = 'value',
            className,
            getOptionLabel = (option) => option[labelKey],
            getOptionValue = (option) => option[valueKey],
            formatOptionLabel = null,
            selectOptions = {}
        } = this.props;

        const displayValue = this._getDisplayValue() || '';
        if (selectAsync) {
            return (
                <Async
                    {...this.props}
                    ref={(input) => {
                        this.selectInput = input;
                    }}
                    getOptionLabel={getOptionLabel}
                    getOptionValue={getOptionValue}
                    value={displayValue}
                    onChange={this._handleOnChange}
                    onBlur={this.handleBlur}
                    ignoreCase={false}
                    isDisabled={disabled}
                    className={cns('verb-select no-padding', className)}
                    classNamePrefix={'verb-select'}
                />
            );
        }

        return (
            <div className={cns(this.props.styleProps)}>
                <Select
                    {...this.props}
                    ref={(input) => {
                        this.selectInput = input;
                    }}
                    getOptionLabel={getOptionLabel}
                    getOptionValue={getOptionValue}
                    value={displayValue}
                    onChange={this._handleOnChange}
                    onBlur={this.handleBlur}
                    isDisabled={disabled}
                    className={cns('verb-select no-padding', className)}
                    classNamePrefix={'verb-select'}
                    formatOptionLabel={formatOptionLabel || null}
                    {...selectOptions}
                />
                {this.props.helpBlockSection}
            </div>
        );
    }
}

export default VerbSelect;
